import React, { ReactElement } from 'react';

import { Button } from 'components/Button';
import CloseIcon from 'components/Icons/CloseIcon';
import { BaseProps } from 'components/Modal/components/BaseContent/BaseContent.types';

import styles from './LandingModalBase.module.scss';

function LandingModalBase({
  children,
  onClose,
  primaryActionText,
}: BaseProps): ReactElement {
  return (
    <div className={styles.wrapper}>
      <CloseIcon
        onClick={onClose}
        iconColor="#fff"
        width={15}
        height={15}
        className={styles.closeIcon}
      />
      {children}
      <Button
        variant="secondary"
        className={styles.button}
        block
        onClick={onClose}>
        <div>{primaryActionText}</div>
      </Button>
    </div>
  );
}

export { LandingModalBase };
